import React, { useState } from "react";
import { fullName } from "../../../../../../../utils/format";
import cn from "classnames";
import Avatar from "../../../../../../../components/Avatar/Avatar";
import { Playlist, PlaylistItem } from "../../../../type";
import ProgressBar from "../../../../../../../design-system-components/ProgressBar/ProgressBar";
import ProgressionModal from "./ProgressionModal/ProgressionModal";
import { VisuallyHidden } from "@evidenceb/athena-common/ui/VisuallyHidden";
import { defineMessages, useIntl } from "react-intl";
import { useStudent } from "../../../../../../../hooks/useSession";

import "./Recipient.scss";

type Props = {
    exercisesDone?: number;
    className?: string;
    playlist: Playlist<PlaylistItem>;
    studentId: string;
};

const Recipient = ({
    className,
    exercisesDone,
    playlist,
    studentId,
}: Props) => {
    const intl = useIntl();

    const [isProgressionModalOpen, setIsProgressionModalOpen] = useState(false);

    const student = useStudent({ studentId });
    if (!student) return null;
    const studentFullName = fullName(student, {
        capitalizeLastName: true,
    });

    return (
        <>
            <div className={cn("recipient", className)}>
                <div className="recipient__name-container">
                    <Avatar
                        name={`${student.firstname} ${student.lastname}`}
                        colors={{
                            background: "var(--element-background-avatar)",
                            text: "var(--text-main-inverted)",
                        }}
                    />
                    <div className="recipient__name">{studentFullName}</div>
                </div>

                {typeof exercisesDone !== "undefined" && (
                    <div className="recipient__progress">
                        <span className="recipient__progress-label">
                            {exercisesDone}/{playlist.learning_items.length}
                        </span>
                        <div className="recipient__progress-bar">
                            <ProgressBar
                                height={8}
                                value={
                                    (exercisesDone /
                                        playlist.learning_items.length) *
                                    100
                                }
                                colors={{
                                    foreground:
                                        "var(--element-teacher-default)",
                                    background:
                                        "var(--element-teacher-disabled)",
                                }}
                            />
                        </div>
                    </div>
                )}

                <button
                    className="recipient__modal-button"
                    onClick={() => setIsProgressionModalOpen(true)}
                >
                    <VisuallyHidden as="span">
                        {intl.formatMessage(messages.openProgressionModal, {
                            studentName: studentFullName,
                        })}
                    </VisuallyHidden>
                </button>
            </div>

            <ProgressionModal
                open={isProgressionModalOpen}
                onClose={() => setIsProgressionModalOpen(false)}
                student={student}
                playlist={playlist}
            />
        </>
    );
};
export default Recipient;

const messages = defineMessages({
    openProgressionModal: {
        id: "playlist-progression-openModal",
        defaultMessage: "See {studentName}'s progress",
    },
});
